// MapClusterControl.js
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

const MapClusterControl = ({ plantations, isClusteringEnabled, onClusteringChange }) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    // Create clustering control
    const clusterControl = L.control({ position: 'topleft' });
    
    clusterControl.onAdd = function() {
      const div = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
      div.innerHTML = `
        <a href="#" title="Toggle Clustering" style="
          display: block;
          width: 30px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          text-decoration: none;
          color: ${isClusteringEnabled ? '#fff' : '#000'};
          background-color: ${isClusteringEnabled ? '#007bff' : '#fff'};
          border: 2px solid rgba(0,0,0,0.2);
          border-radius: 4px;
          font-weight: bold;
          font-size: 18px;
        ">C</a>
      `;
      
      div.onclick = (e) => {
        L.DomEvent.stopPropagation(e);
        L.DomEvent.preventDefault(e);
        onClusteringChange(!isClusteringEnabled);
        return false;
      };
      
      return div;
    };

    // Add control to map
    clusterControl.addTo(map);

    return () => {
      map.removeControl(clusterControl);
    };
  }, [map, isClusteringEnabled, onClusteringChange]);

  return null;
};

export default MapClusterControl;